import {Stack} from "@mui/material";
import React, {useRef, useState} from "react";
import {ElementDto} from "../../../../../common/apis/element/ElementDto";
import {AttributeDefinitionDto} from "../../../../../common/apis/stereotype/AttributeDefinitionDto";
import {ReferenceDefinitionDto} from "../../../../../common/apis/stereotype/ReferenceDefinitionDto";
import {StereotypeLayoutDefinitionDto} from "../../../../../common/apis/stereotype/StereotypeLayoutDefinitionDto";
import {ButtonLayout, NegativeButtons, PositiveButtons} from "../../../../../components/button/ButtonLayout";
import {CancelButton} from "../../../../../components/button/CancelButton";
import {SaveButton} from "../../../../../components/button/SaveButton";
import Dialog from "../../../../../components/dialogs/Dialog";
import DialogActions from "../../../../../components/dialogs/DialogActions";
import DialogContent from "../../../../../components/dialogs/DialogContent";
import DialogTitle from "../../../../../components/dialogs/DialogTitle";
import {t} from "../../../../../store/localization/TranslMessasge";
import {ElementTranslationKey} from "../../elements/ElementTranslationKey";
import StereotypeLayoutRenderer, {StereotypeLayoutRendererApi} from "../../stereotypes/layout/StereotypeLayoutRenderer";

interface StereotypeAttrsUpdateDialogProps {
    open: boolean;
    onClose: () => void;
    onUpdate?: () => void;
    element: ElementDto;
    layoutDefinition: StereotypeLayoutDefinitionDto;
    attributeDefinitions: AttributeDefinitionDto[];
    referenceDefinitions: ReferenceDefinitionDto[];
}

export default function StereotypeAttrsUpdateDialog(props: Readonly<StereotypeAttrsUpdateDialogProps>) {
    const {open, element, layoutDefinition, attributeDefinitions, referenceDefinitions, onUpdate, onClose} = props;

    const stereotypeRendererApiRef = useRef<StereotypeLayoutRendererApi>(null);
    const [inProgress, setInProgress] = useState(false);

    function save() {
        setInProgress(true);
        stereotypeRendererApiRef.current?.save()
                .then((success) => {
                    if (success) {
                        onUpdate?.();
                        resetAndClose();
                    }
                })
                .finally(() => setInProgress(false));
    }

    function resetAndClose() {
        stereotypeRendererApiRef.current?.reset();
        onClose();
    }

    try {
        return (
                <Dialog open={open} onClose={resetAndClose} maxWidth={"lg"}>
                    <DialogTitle title={t(ElementTranslationKey.EDIT_ATTRIBUTES)}
                            onDialogClosed={resetAndClose} />
                    <DialogContent>
                        <Stack mt={0.5}>
                            <StereotypeLayoutRenderer
                                    ref={stereotypeRendererApiRef}
                                    element={element}
                                    editMode={true}
                                    layoutDefinition={layoutDefinition}
                                    attributeDefinitions={attributeDefinitions}
                                    referenceDefinitions={referenceDefinitions} />
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <ButtonLayout>
                            <PositiveButtons>
                                <SaveButton onClick={save} disabled={inProgress} />
                            </PositiveButtons>
                            <NegativeButtons>
                                <CancelButton onClick={resetAndClose} disabled={inProgress} />
                            </NegativeButtons>
                        </ButtonLayout>
                    </DialogActions>
                </Dialog>
        );
    } catch {
        return null;
    }
}